import { Component, OnInit } from '@angular/core';
import { RoleEnum } from '@app/shared/enum/role.enum';
import { TradeInSytemCollection } from '@app/shared/models/tradein-system.collection';

@Component({
  selector: 'app-tvo',
  templateUrl: './tvo.component.html',
  styleUrls: ['./tvo.component.sass'],
})
export class TvoComponent {
  tradinSytem = TradeInSytemCollection.find((t) => t.role === RoleEnum.TVO);
  buttons = [
    {
      icon: 'collections_bookmark',
      label: 'Triagem',
      color: '#003B71',
      route: 'triagem/buscar',
    },
    {
      icon: 'description',
      label: 'Trades',
      color: '#FF6600',
      route: 'pedidos',
    },
  ];
}
